import type {ICodePush} from './types';

export const codePush: ICodePush = {
  syncForUpdates: () => Promise.resolve(false),
  installPendingUpdate: () => Promise.resolve(null),
  installUpdate: () => Promise.resolve(null),
};
